import React from 'react';
import AurPopup from '../../../common/aur-popup/AurPopup';
import AurIcon, {IconColors, IconNames} from '../../../common/aur-icon/AurIcon';
import {noop} from 'lodash';

interface IErrorDialogProps {
  open: boolean;
  title: string;
  description: string;
  button: string;
  onOkClicked: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const ErrorDialog: React.FC<IErrorDialogProps> = ({
  open,
  title,
  description,
  button,
  onOkClicked,
}) => {
  return (
    <AurPopup
      className="inactivity-popup-modal error-modal custom-tag-dialog-model"
      open={open}
      showPopupTitle={true}
      showPopupHeading={true}
      showCancelOption={false}
      showCloseIcon={false}
      headingIcon={
        <AurIcon
          icon={IconNames.Error}
          color={IconColors.Critical}
          customClassName="heading-warning-icon"
        />
      }
      popupHeading={title}
      popupContent={description}
      labelActionOk={button}
      aria-label={title}
      aria-description={description}
      onOk={onOkClicked}
      onCancel={noop}
    />
  );
};

export {ErrorDialog};
